import { useContext, useCallback } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

export function useTranslation() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }

  const t = useCallback((key) => {
    if (!context.translations) return key;

    try {
      const result = key.split('.').reduce((obj, k) => obj[k], context.translations);
      return result || key;
    } catch (error) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }, [context.translations]);

  return { t, ready: context.ready };
} 